module.exports = __webpack_public_path__ + "52e3086e09b103fd4d7ca03e7ef72003.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/bookshelves/bookshelf-basic-3.png
// module id = 3382
// module chunks = 0